<template>
  <div id="app">
    <header class="navbar navbar-expand-lg navbar-dark fixed-top" style="background-color: var(--ct-dark); box-shadow: 0 2px 10px rgba(0,0,0,0.2);">
      <div class="container">
        <router-link class="navbar-brand" to="/">
          <img src="@/assets/ctgrid-logo-dark.svg" alt="CT Grid" width="120px">
        </router-link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ms-auto d-flex align-items-center">
            <li class="nav-item">
              <router-link class="nav-link" to="/about">{{ t('navigation.about') }}</router-link>
            </li>
<!--            <li class="nav-item">-->
<!--              <router-link class="nav-link" to="/for-traders">{{ t('navigation.forTraders') }}</router-link>-->
<!--            </li>-->
<!--            <li class="nav-item">-->
<!--              <router-link class="nav-link" to="/for-brokers">{{ t('navigation.forBrokers') }}</router-link>-->
<!--            </li>-->
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="marketsDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                {{ t('navigation.markets.title') }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="marketsDropdown">
<!--                <li><router-link class="dropdown-item" to="/markets/crude-oil">Crude Oil</router-link></li>-->
                <li><router-link class="dropdown-item" to="/markets/japan-power">{{ t('navigation.markets.subitems.japanPower') }}</router-link></li>
<!--                <li><router-link class="dropdown-item" to="/markets/lng">LNG</router-link></li>-->
              </ul>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/news">{{ t('navigation.news') }}</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/blog">{{ t('navigation.blog') }}</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/downloads">{{ t('navigation.downloads') }}</router-link>
            </li>
            <li class="nav-item">
              <router-link class="ct-btn-primary" to="/contact">{{ t('navigation.requestDemo') }}</router-link>
            </li>
            <li class="nav-item">
              <LanguageSwitcher />
            </li>
          </ul>
        </div>
      </div>
    </header>

    <main class="bg-dark">
      <router-view />
    </main>

    <footer class="ct-footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 mb-4 mb-lg-0">
            <img src="@/assets/ctgrid-logo-dark.svg" alt="CT Grid" height="40" class="mb-4">
            <p class="text-muted">
              {{ t('footer.blurb') }}
            </p>
          </div>
          <div class="col-lg-2 offset-lg-2 mb-4 mb-lg-0">
            <h5 class="text-white mb-3">{{ t('footer.company') }}</h5>
            <ul class="list-unstyled">
              <li class="mb-2"><router-link to="/about" class="ct-footer-link">{{ t('footer.about') }}</router-link></li>
              <li class="mb-2"><router-link to="/contact" class="ct-footer-link">{{ t('footer.contact') }}</router-link></li>
            </ul>
          </div>
          <div class="col-lg-2 mb-4 mb-lg-0">
            <h5 class="text-white mb-3">{{ t('footer.platform') }}</h5>
            <ul class="list-unstyled">
              <li class="mb-2"><router-link to="/for-traders" class="ct-footer-link">{{ t('footer.forTraders') }}</router-link></li>
              <li class="mb-2"><router-link to="/for-brokers" class="ct-footer-link">{{ t('footer.forBrokers') }}</router-link></li>
              <li class="mb-2"><router-link to="/downloads" class="ct-footer-link">{{ t('footer.downloads') }}</router-link></li>
            </ul>
          </div>
          <div class="col-lg-2">
            <h5 class="text-white mb-3">{{ t('footer.legal') }}</h5>
            <ul class="list-unstyled">
              <li class="mb-2"><router-link to="/legal/privacy-policy" class="ct-footer-link">{{ t('footer.privacyPolicy') }}</router-link></li>
              <li class="mb-2"><router-link to="/legal/terms-of-service" class="ct-footer-link">{{ t('footer.termsOfService') }}</router-link></li>
            </ul>
          </div>
        </div>
        <hr class="mt-4 mb-4" style="border-color: rgba(255,255,255,0.1);">
        <div class="d-flex justify-content-between align-items-center flex-column flex-md-row">
          <p class="text-muted mb-3 mb-md-0">{{ t('footer.copyright', { year: currentYear }) }}</p>
          <div>
            <a href="https://www.linkedin.com/company/commodity-technologies/" class="ct-footer-link me-3"><i class="fab fa-linkedin"></i></a>
            <a href="#" class="ct-footer-link me-3"><i class="fab fa-twitter"></i></a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { computed, onMounted } from 'vue';
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue';

export default {
  name: 'App',
  components: {
    LanguageSwitcher
  },
  setup() {
    // Initialize i18n
    const { t, locale } = useI18n();

    // Compute current year
    const currentYear = computed(() => {
      return new Date().getFullYear();
    });
    // Function to set up auto-collapse of navbar when links are clicked
    const setupNavbarAutoCollapse = () => {
      // Select all nav links EXCEPT dropdown toggles
      const navLinks = document.querySelectorAll('.navbar-nav .nav-link:not(.dropdown-toggle), .navbar-nav .dropdown-item, .navbar-nav .ct-btn-primary');
      const navbarToggler = document.querySelector('.navbar-toggler');
      const navbarCollapse = document.querySelector('.navbar-collapse');

      navLinks.forEach(link => {
        link.addEventListener('click', () => {
          // Only collapse if the navbar is expanded and we're on a small screen
          if (window.getComputedStyle(navbarToggler).display !== 'none') {
            // Check if Bootstrap is available
            if (window.bootstrap && window.bootstrap.Collapse) {
              const bsCollapse = new window.bootstrap.Collapse(navbarCollapse);
              bsCollapse.hide();
            } else {
              // Fallback: toggle the 'show' class manually
              navbarCollapse.classList.remove('show');
            }
          }
        });
      });
    };
    // Initialize dropdowns after component is mounted
    onMounted(() => {
      // Use setTimeout to ensure DOM is fully loaded
      setTimeout(() => {
        // Manually initialize dropdowns
        const dropdownElementList = document.querySelectorAll('.dropdown-toggle');
        if (window.bootstrap && window.bootstrap.Dropdown) {
          dropdownElementList.forEach(dropdownToggle => {
            new window.bootstrap.Dropdown(dropdownToggle);
          });
        } else {
          console.error('Bootstrap Dropdown component not found');
        }
        setupNavbarAutoCollapse();
      }, 100);
    });

    // Return values to template
    return {
      t,
      locale,
      currentYear
    };
  }
}
</script>

<style>
@import '@/assets/css/dark-theme.css';

/* Additional global styles */
body {
  padding-top: 72px; /* For fixed navbar */
}

/* Override Bootstrap components for dark theme */
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.8);
}

.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:focus {
  color: var(--ct-orange);
}

.navbar-dark .navbar-nav .router-link-exact-active {
  color: var(--ct-orange);
}

/* Dropdown specific styles */
.dropdown-menu {
  background-color: var(--ct-dark-tertiary);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5);
}

.dropdown-item {
  color: rgba(255, 255, 255, 0.8);
}

/* Override Bootstrap's default blue focus/hover state */
.dropdown-item:focus,
.dropdown-item:hover {
  background-color: rgba(253, 153, 0, 0.1); /* Light orange background */
  color: var(--ct-orange);
}

/* Update active style to use your orange accent color */
.dropdown-item.active,
.dropdown-item:active {
  background-color: var(--ct-orange);
  color: #000;
}

/* Add this to the <style> section of App.vue */
@media (max-width: 991.98px) {
  /* This media query targets screens smaller than Bootstrap's lg breakpoint */
  .navbar-collapse .navbar-nav .nav-item {
    padding: 0.5rem 0; /* Add vertical padding to all nav items */
  }

  /* Make the demo button have proper spacing */
  .navbar-nav .ct-btn-primary {
    margin: 0.75rem 0; /* Increased margin for the button */
    display: block; /* Make it full width on mobile */
    text-align: center; /* Center the text */
    padding: 0.75rem 1.5rem; /* Add more padding inside the button */
  }
}

/* Global styles for the CT button in the navbar */
.navbar-nav .ct-btn-primary {
  padding: 0.5rem 1rem; /* Default padding for the button */
  border-radius: 4px; /* Optional: add rounded corners */
  transition: all 0.2s ease; /* Smooth transition for hover effects */
}

/* Ensure the button is vertically aligned with other nav items in desktop view */
@media (min-width: 992px) {
  .navbar-nav .ct-btn-primary {
    margin-left: 0.75rem; /* Add some space from the previous nav item */
  }
}

/* Alert and form overrides */
.alert {
  border-radius: 6px;
}

.form-control {
  border-radius: 6px;
}

.form-control:focus {
  box-shadow: 0 0 0 0.2rem rgba(253, 153, 0, 0.25);
}
.navbar-dark .navbar-nav .router-link-exact-active.ct-btn-primary {
  color: #000 !important; /* Keep text black */
}
</style>